<template>
  <div class="flex justify-center">
    <div v-if="show.subscribeDone" class="result-form">
      <div class="text-center">
        <premiumImage type="logo" class="h-24 mt-40" />
        <h2 class="font-bold pt-40">{{ $t('premium.addon.done') }}</h2>
        <h5 class="font-medium mt-8">{{ $t('premium.addon.useDiscountNow') }}</h5>
        <button @click="close" class="btn btn-solid btn-blue-light mt-40 w-full">{{ $t('confirm') }}</button>
      </div>
    </div>
    <div v-else-if="show.subscribeFailed" class="result-form">
      <div class="text-center">
        <h4>{{ $t('premium.addon.failed') }}</h4>
        <button class="btn btn-sm btn-ghost btn-grey cursor-pointer text-sm mt-16" @click="close">
          {{ $t('close') }}
        </button>
      </div>
    </div>
    <div v-else-if="show.resubscribeFailed" class="result-form">
      <div class="text-center">
        <h4>{{ $t('premium.addon.upgradeFailed') }}</h4>
        <button class="btn btn-sm btn-ghost cursor-pointer text-premium-dark border-premium-dark text-sm mt-16" @click="toPremiumHome">
          {{ $t('goTo') }}
        </button>
      </div>
    </div>
    <div v-else-if="show.loginExpired" class="result-form">
      <div class="text-center">
        <h4>{{ $t('premium.addon.loginExpired') }}</h4>
        <button class="btn btn-sm btn-blue-light btn-ghost cursor-pointer text-premium-dark border-premium-dark text-sm mt-16" @click="redirectLogin">
          {{ $t('confirm') }}
        </button>
      </div>
    </div>
    <div v-else class="subscribe-form w-full">
      <iframe v-if="addonPageSrc" class="h-full w-full" :src="addonPageSrc" />
      <button v-else-if="!loading.premiumPage" class="btn btn-sm btn-ghost cursor-pointer text-premium-dark border-premium-dark text-sm" @click="toPremiumPage">
        {{ $t('premium.addon.redirectToPremiumPage') }}
      </button>
    </div>
  </div>
</template>

<script>
import qs from 'query-string'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PremiumAddon',
  props: {
    savedPrice: {
      type: [String, Number],
      default: 0
    }
  },
  data () {
    return {
      addonPageSrc: '',
      loading: {
        premiumPage: false
      },
      show: {
        subscribeDone: false,
        subscribeFailed: false,
        resubscribeFailed: false,
        loginExpired: false
      }
    }
  },
  computed: {
    ...mapGetters({
      premiumUrl: 'user/premiumUrl',
      premiumUrlAddon: 'user/premiumUrlAddon',
      premiumUrlRedirect: 'user/premiumUrlRedirect'
    })
  },
  mounted () {
    this.getPremiumUrl()
    this.watchMessage()
  },
  beforeDestroy () {
    if (this.show.subscribeDone) {
      window.location.reload()
    }
    window.removeEventListener('message', this.handleMessageEvent, false)
  },
  methods: {
    ...mapActions([
      'user/goLogin',
      'user/loginPremium'
    ]),
    close () {
      this.$emit('close')
    },
    getPremiumUrl () {
      this.loading.premiumPage = true
      this['user/loginPremium']()
        .then(response => {
          const { accessToken } = response.data

          if (accessToken) {
            const query = qs.stringify({ accessToken, saved: this.savedPrice, project: 'owljourney' })

            this.addonPageSrc = `${this.premiumUrlAddon}?${query}`
          } else {
            this.show.loginExpired = true
          }
        })
        .finally(() => {
          this.loading.premiumPage = false
        })
    },
    handleMessageEvent (event) {
      const targetOrigin = new URL(this.premiumUrlAddon).origin

      if (event.origin === targetOrigin) {
        switch (event.data) {
          case 'PREMIUM_UPDATE_DONE':
            this.show.subscribeDone = true
            break
          case 'PREMIUM_UPDATE_FAILED':
            this.show.subscribeFailed = true
            break
          case 'PREMIUM_RESUBSCRIBE_FAILED':
            this.show.resubscribeFailed = true
            break
          case 'PREMIUM_UPDATE_CANCEL':
            this.close()
            break
        }
      }
    },
    redirectLogin () {
      this['user/goLogin']()
    },
    toPremiumHome () {
      this.close()
      window.open(this.premiumUrl, '_blank')
    },
    toPremiumPage () {
      window.open(this.premiumUrlRedirect, '_blank')
    },
    watchMessage () {
      window.addEventListener('message', this.handleMessageEvent, false)
    }
  }
}
</script>

<style lang="sass" scoped>
.subscribe-form
  @apply flex justify-center items-center
  height: 70vh
.result-form
  @apply flex justify-center px-16 py-40
  @screen md
    @apply px-40
</style>
